export const DefaultRewardsProgramName = 'Rewards';
export const DefaultRewardsProgramDescription = 'Apply the discounts you’ve earned to your online order!';
export const DefaultRewardsProgramEnrollment = 'Unlock exclusive discounts as you shop with us.';

// In Canada it is illegal to reference 'rewards'
export const CanadianDefaultRewardsProgramName = 'Member Club';
export const CanadianDefaultRewardsProgramDescription = 'View your member club wallet to apply towards your order!';
export const CanadianDefaultRewardsProgramEnrollment = 'Unlock member benefits as you shop with us.';
